import React from 'react';

function  notification(size: any) {
  return (
        <svg width={size} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.52992 14.7696C2.31727 16.1636 3.268 17.1312 4.43205 17.6134C8.89481 19.4622 15.1052 19.4622 19.5679 17.6134C20.732 17.1312 21.6827 16.1636 21.4701 14.7696C21.3394 13.9129 20.6932 13.1995 20.2144 12.5029C19.5873 11.5793 19.525 10.5718 19.5249 9.5C19.5249 5.35786 16.1559 2 12 2C7.84413 2 4.47513 5.35786 4.47513 9.5C4.47503 10.5718 4.41272 11.5793 3.78561 12.5029C3.30684 13.1995 2.66061 13.9129 2.52992 14.7696Z"
                stroke="#7F7F7F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 19C8.45849 20.7252 10.0755 22 12 22C13.9245 22 15.5415 20.7252 16 19" stroke="#7F7F7F"
                  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="18.0371" cy="5" r="4" fill="#E71F1F"/>
        </svg>

  );
}

export default notification;
